import { Component, ViewChild, trigger, transition, style, state, animate, keyframes, Input } from '@angular/core';
import { NavController, Slides } from 'ionic-angular';

@Component({
  selector: 'onboarding-reserve',
  templateUrl: 'onboarding-reserve.html',
  animations: [

    trigger('bounce', [
      state('*', style({
        transform: 'translateX(0)'
      })),
      transition('* => rightSwipe', animate('700ms ease-out', keyframes([
        style({ transform: 'translateX(0)', offset: 0 }),
        style({ transform: 'translateX(-65px)', offset: .3 }),
        style({ transform: 'translateX(0)', offset: 1 })
      ]))),
      transition('* => leftSwipe', animate('700ms ease-out', keyframes([
        style({ transform: 'translateX(0)', offset: 0 }),
        style({ transform: 'translateX(65px)', offset: .3 }),
        style({ transform: 'translateX(0)', offset: 1 })
      ])))
    ])
  ]
})

export class OnboardingReserveComponent {

  @ViewChild(Slides) slides: Slides;
  @Input() localstorageName: string = 'viewOnBoardingReserve';
  @Input() configColor: any;

  public skipMsg: string = "Omitir";
  public showModal: boolean = false;

  constructor(public navCtrl: NavController) {
  }

  public ngOnInit() {
    let valueView = window.localStorage.getItem(this.localstorageName);
    if (valueView !== "true") {
      this.showModal = true;
    }
  }

  skip() {
    window.localStorage.setItem(this.localstorageName, "true");
    setTimeout(() => {
      this.showModal = false;
    }, 600);
  }

  slideChanged() {
    if (this.slides.isEnd())
      this.skipMsg = "Esta bien, lo tengo";
  }
}



// WEBPACK FOOTER //
// ./src/components/onboarding-reserve/onboarding-reserve.ts